// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const RedoIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="RedoIcon" ref={forwardedRef} {...props}>
      <path d="M18 8.243 13.757 4l-1.06 1.06 2.434 2.435H4a1 1 0 0 0-1 1v4.5a1 1 0 0 0 1 1h4v-1.5H4.5v-3.5h10.627l-2.43 2.43 1.06 1.06z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const RedoIcon = /* @__PURE__ */ Object.assign(RedoIconComponent, {
  displayName: 'RedoIcon',
});
